// extracted by mini-css-extract-plugin
module.exports = {"container":"_1qAH0Ke6tmNaye8guTWULH","cancelBtn":"_2GGFucj3P_yPMNTPaUNkl9","icon":"_10nxKt3A5DgKByi9tKorBT","saveBtn":"_19v7WRzWy0owkHDuahSn-R"};